import { FC, useEffect } from "react";
import { Carousel } from 'antd';
import wide1 from '../../assets/1920-1.png';
import wide2 from '../../assets/1920-2.png';
import wide3 from '../../assets/1920-3.png';
import wide4 from '../../assets/1920-4.png';
import wide5 from '../../assets/1920-5.png';
import narrow1 from '../../assets/1440-1.png';
import narrow2 from '../../assets/1440-2.png';
import narrow3 from '../../assets/1440-3.png';
import narrow4 from '../../assets/1440-4.png';
import narrow5 from '../../assets/1440-5.png';
import styles from './Swiper.module.less';
import { useWinSize } from "../../utils/useWinSize";

const Swiper: FC = (props) => {
    const size = useWinSize();
    return (
        <div className={styles.body}>
            {size.width <= 1440 ?
                <Carousel beforeChange={props.getImage} autoplay autoplaySpeed={5000}>
                    <div>
                        <img src={narrow5} alt="" />
                    </div>
                    <div>
                        <img src={narrow1} alt="" />
                    </div>
                    <div>
                        <img src={narrow2} alt="" />
                    </div>
                    <div>
                        <img src={narrow3} alt="" />
                    </div>
                    <div>
                        <img src={narrow4} alt="" />
                    </div>
                </Carousel >
                    :
                <Carousel beforeChange={props.getImage} autoplay autoplaySpeed={5000}>
                    <div>
                        <img src={wide5} alt="" />
                    </div>
                    <div>
                        <img src={wide1} alt="" />
                    </div>
                    <div>
                        <img src={wide2} alt="" />
                    </div>
                    <div>
                        <img src={wide3} alt="" />
                    </div>
                    <div>
                        <img src={wide4} alt="" />
                    </div>
                </Carousel>
            }
        </div>
    );
}

export default Swiper;